import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CaseListFilterDto, ValueAtRiskFilterDto } from 'src/app/reports/dto/report-filters-dto';

import * as theGlobals from '../shared/globals';

@Injectable()

export class ReportService {

    private myUrl = theGlobals.setEnv().funcUrl;

    constructor(private http: HttpClient) {
    }

    getExpirationList(sortBy: string): Observable<Blob>
  {
    const xUrl = this.myUrl + '/report/expirationlist/' + sortBy;
    return this.http.get(xUrl, { responseType: 'blob' });
  }
    getComplexCaseList(): Observable<Blob>
    {
      const xUrl = this.myUrl + '/report/complexcaselist';
      return this.http.get(xUrl, { responseType: 'blob' });

    }
    getCaseList(caseListDto: CaseListFilterDto): Observable<Blob>
    {
      let xUrl = this.myUrl + '/report/caselist';
      if (caseListDto.exportExcel ) {
        xUrl = xUrl + '/ex';
      }
      return this.http.post(xUrl, caseListDto,{ responseType: 'blob' });
    }
    getValueAtRisk(valAtRiskDto: ValueAtRiskFilterDto): Observable<Blob>
    {
      const xUrl = this.myUrl + '/stats/valuediff';
      return this.http.post(xUrl, valAtRiskDto,{ responseType: 'blob' });
    }

}
